import type { Step } from "react-joyride";

export const otRuleCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ສ້າງຂໍ້ກຳນົດ OT ໃໝ່. ກຳນົດຊື່, ປະເພດວັນ, ອັດຕາຄູນ ແລະ ຊ່ວງວັນທີ່ມີຜົນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-rule-create-back"]',
    content: "ກັບໄປລາຍການຂໍ້ກຳນົດ OT. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-rule-create-form"]',
    content:
      "ຕື່ມຂໍ້ມູນຂໍ້ກຳນົດ: ຊື່, ປະເພດວັນ (ວັນທຳມະດາ/ວັນພັກ), ອັດຕາຄູນ, ວັນທີ່ເລີ່ມ-ສິ້ນສຸດ, ສະຖານະ ແລະ ຄຳອະທິບາຍ. ສາມາດຕື່ມຕົວຢ່າງໄດ້.",
    placement: "top",
  },
];
